module.exports = __webpack_public_path__ + "static/nodes-31c0ac77bf34e31fd0ba530378a66d16.png";